import { useStore } from 'features/ListBuilder/infra/react/ListBuilderStore/useStore'

export const useListsPagination = () =>
  useStore(store => ({
    pageInfo: store.listsPagination.state,
    setPage: store.listsPagination.execute,
  }))
